import React, {Component} from 'react';
import {translate} from '../../helperFunctions/translation';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {TableCellTypes} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import Button from '@material-ui/core/Button';
import {IBrandsStore} from '../../mobx-store/storeInterfaces/brandsStoreInterface';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router';

interface IProps extends RouteComponentProps {
    brandsStore: IBrandsStore;
}

@inject('brandsStore')
@observer
class BrandsScreen extends Component<IProps> {
    addButton: any;
    tableHeader: any = [];
    tableData: any[] = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string;

    constructor(props: IProps) {
        super(props);
        this.title = 'Manage Brands';
    }

    handleTableButtonCellClicked = (index: string, key: string) => {
            this.props.history.push(`/brands/${index}/${key}`);
    }

    handelAdd = (): void => {
        this.props.history.push('/brands/new');
    }

    getAddAdButton = () => {
        return {
            title: 'Add Brand',
            onAdd: this.handelAdd,
        };
    }

    getAdsTableHeader = () => {
        return [
            {
                title: 'Brand Name',
            },
            {
                title: 'Edit',
            }
        ];
    }

    getAdsTableCellTypes = (): TableCellTypes[] => {
        return [
            {
                cellType: 'Text',
                key: 'brandName',
            },
            {
                cellType: 'Button',
                key: 'edit',
                onClick: this.handleTableButtonCellClicked
            }
        ];
    }

    render() {
        const {brands, loaded} = this.props.brandsStore;
        this.addButton = this.getAddAdButton();
        this.tableHeader = this.getAdsTableHeader();
        this.tableData = brands;
        this.tableCellTypes = this.getAdsTableCellTypes();
        return loaded && (
            <div>
                <GeneralTableComponent emptyMessage='There are no brands added yet'
                                       title={this.title}
                                       tableHeader={this.tableHeader}
                                       tableData={this.tableData}
                                       tableCellTypes={this.tableCellTypes}
                                       addButton={this.addButton}/>
            </div>
        );
    }

    componentDidMount() {
        this.props.brandsStore.getBrands();
    }

}

export default BrandsScreen;
